import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=da1431ae&scoped=true"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"
import style0 from "./Datatable.vue?vue&type=style&index=0&id=da1431ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1431ae",
  null
  
)

export default component.exports